import React from "react";
import {
  DatePicker,
  Dropdown,
  TextField,
  Spinner,
  Label,
  SpinnerSize,
  Dialog,
  DialogType,
  DialogFooter,
  PrimaryButton,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  CheckboxVisibility
} from "office-ui-fabric-react";
import "./style.css";
import moment from "moment";
import axios from "axios";
import config from "../../../config";


export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.inputs = [];

    this.oldData = this.copyData(props.data);

    this.state = {
      show: false,
      state: "editing",
      data: this.copyData(props.data),
      showDialog: false,
      showInsuranceDoc: false,
      showInsuranceDocList: false,
      healthPlans: [],
    };

  }

  componentDidMount() {
    axios.get(`${config.apiUrl}/healthplan/list`).then(({data}) => {
      this.setState({
        healthPlans: data
            .map((e) => ({
              key: e._id,
              text: `${e.name}`,
            })),
      });
    });
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    let prevdata = this.copyData(prevProps.data)
    let curdata = this.copyData(this.props.data);

    if(!this.sameInsuranceDocs(prevdata,curdata))
      this.setState({data:curdata});

  }


  sameInsuranceDocs(prevdata,curdata){

    
    if(prevdata.insurancedoc.length!==curdata.insurancedoc.length)
      return false;

    var result = prevdata.insurancedoc.filter(function (el1) {
        return curdata.insurancedoc.some(function (el2) {
            return el1.filename === el2.filename; // return the ones with equal id
       });
    });

    return prevdata.insurancedoc.length===result.length;

  }

  copyData(data) {
    return {
      _id: data._id,
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      middleName: data.middleName || "",
      address: data.address || "",
      address2: data.address2 || "",
      age: data.age || 0,
      city: data.city || "",
      emailAddress: data.emailAddress || "",
      phone: data.phone || "",
      state: data.state || "",
      zipCode: data.zipCode || "",
      zipCodePlus: data.zipCodePlus || "",
      DOB: data.DOB || "",

      relativeFirstName: data.relativeFirstName || "",
      relativeLastName: data.relativeLastName || "",
      relativeMiddleName: data.relativeMiddleName || "",
      relativeAddress: data.relativeAddress || "",
      relativeAddress2: data.relativeAddress2 || "",
      relativeAge: data.relativeAge || 0,
      relativeCity: data.relativeCity || "",
      relativeEmailAddress: data.relativeEmailAddress || "",
      relativePhone: data.relativePhone || "",
      relativeState: data.relativeState || "",
      relativeZipCode: data.relativeZipCode || "",
      relativeZipCodePlus: data.relativeZipCodePlus || "",

      medicareNumber: data.medicareNumber || "",
      partADate: data.partADate ? new Date(data.partADate) : new Date(),
      partBDate: data.partBDate ? new Date(data.partBDate) : new Date(),
      insurancePlan: data.insurancePlan || "",
      medicalNumber: data.medicalNumber || "",
      medicareIssueDate: data.medicareIssueDate
        ? new Date(data.medicareIssueDate)
        : new Date(),
      HMOorFFS: data.HMOorFFS || "HMO",
      mcHMOorFFS: data.mcHMOorFFS || "HMO",
      clinicName: data.clinicName || "",
      clinicDoctor: data.clinicDoctor || "",
      hospitalOne: data.hospitalOne || "",
      hospitalTwo: data.hospitalTwo || "",
      medications: data.medications || "",
      diagnosisOne: data.diagnosisOne || "",
      diagnosisTwo: data.diagnosisTwo || "",
      hmoHappy:
        data.hmoHappy == true
          ? true
          : data.hmoHappy == false
          ? false
          : undefined,
      homHappyReason: data.homHappyReason || "",
      doctorHappy:
        data.doctorHappy == true
          ? true
          : data.doctorHappy == false
          ? false
          : undefined,
      doctorHappyReason: data.doctorHappyReason || "",
      comments: data.comments || "",

      sequentialLeadNumber: data.sequentialLeadNumber || data.seqNumber || "",

      createdAt: data.createdAt || new Date(),
      updatedAt: data.updatedAt || new Date(),
      changedProcessAt: data.changedProcessAt || new Date(),
      healthPlanId: data.healthPlanId || null,
      insurancedoc: data.insurancedoc && Array.isArray(data.insurancedoc)? data.insurancedoc : []
    };
  }

  show() {
    if (this.state.show) {
      return;
    }
    this.oldData = this.copyData(this.props.data);
    this.setState({
      show: true,
      data: this.copyData(this.oldData),
    });

    setTimeout(() => {
      this.refs.firstInput && this.refs.firstInput.focus();
    }, 100);
  }

  hide() {
    this.setState({
      show: false,
    });
  }

  cancel() {
    this.setState({
      data: this.copyData(this.oldData),
    });
    this.props.onCancel && this.props.onCancel();
  }

  save() {
    this.oldData = this.copyData(this.state.data);
    this.props.onSave && this.props.onSave(this.state.data);
    this.setState({
      state: "saving",
    });
    setTimeout(() => {
      this.setState({
        state: "saved",
      });
    }, 1000);
    setTimeout(() => {
      this.setState({
        state: "editing",
      });
    }, 3000);
  }

  valueChange(key, v) {
    var data = this.state.data;
    data[key] = typeof v == "string" ? v : v.key;
    this.setState({
      data: {
        ...data,
      },
    });
  }

  valueChangeMcHMOorFFS(v) {
    var data = this.state.data;
    if (v.key == "FFS"){
      data.healthPlanId = null;
    }
    data['mcHMOorFFS'] = v.key;
    this.setState({
      data: {
        ...data,
      },
    });
  }

  valueDateChange(key, v) {
    var data = this.state.data;
    data[key] = v;
    this.setState({
      data: {
        ...data,
      },
    });
  }

  viewInsuranceDoc(curdoc) {

    this.setState({ showInsuranceDoc: true,
                    currentdocument:curdoc 
                  });

  }

  viewInsuranceDocList(id) {

    this.setState({ showInsuranceDocList: true });

  }  

  showDeleteInsuranceDoc(e) {
    let cid = new URLSearchParams(location.search).get("id");

    if (confirm('Do you want to delete ' +  `${e.filename ? e.filename : ""}` + "?")) {
      axios.get(config.apiUrl + '/customer/deletedoc/'+cid+'/' + e._id)
            .then((customer) => {
              
              this.setState({
                data: this.copyData(customer.data),
              });
             

            })
    }
  }

  render() {
    var data = this.state.data;       
    
    var processCollum = columns.find((e) => e.key == "action");
    processCollum.onRender = (e) => {
      return (
        <div>
          <button className="tbl-btn" onClick={() => this.viewInsuranceDoc(e)}>
            <i className="ms-Icon ms-Icon--View" aria-hidden="true"></i>
          </button>
          <button className="tbl-btn" onClick={() => this.showDeleteInsuranceDoc(e)}>
            <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
          </button>
        </div>
      );
    };
  
 
    if (this.state.show) {
      return (
        
        <div className="lead-form">
          <div className=" ms-Grid">
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Sequential Lead Number"
                  value={data.sequentialLeadNumber}
                  onChanged={(v) => this.valueChange("sequentialLeadNumber", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Added To Lead At"
                  readOnly
                  style={{ background: "#f2f2f2" }}
                  value={moment(data.changedProcessAt).format("MMM DD YYYY")}
                />
              </div>
              <div className="ms-Grid-col ms-u-md2">
                <TextField
                  label="Last Updated At"
                  readOnly
                  style={{ background: "#f2f2f2" }}
                  value={moment(data.updatedAt).format("MMM DD YYYY")}
                />
              </div>
              <div className="ms-Grid-col ms-u-md2">
                <TextField
                  label="Created At"
                  readOnly
                  style={{ background: "#f2f2f2" }}
                  value={moment(data.createdAt).format("MMM DD YYYY")}
                />
              </div>
            </div>
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  ref="firstInput"
                  label="Medicare Number"
                  value={data.medicareNumber}
                  onChanged={(v) => this.valueChange("medicareNumber", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <DatePicker
                  label="Part A Issue Date"
                  formatDate={(date) => moment(date).format("MMM DD YYYY")}
                  value={data.partADate}
                  onSelectDate={(v) => this.valueDateChange("partADate", v)}
                  allowTextInput
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Medical Number"
                  value={data.medicalNumber}
                  onChanged={(v) => this.valueChange("medicalNumber", v)}
                />
              </div>
            </div>
            <div className="ms-Grid-row ">
              {[<div className="ms-Grid-col ms-u-md2">
                <Dropdown
                    label="HMO or FFS"
                    options={[
                      {key: "HMO", text: "HMO"},
                      {key: "FFS", text: "FFS"},
                    ]}
                    selectedKey={data.mcHMOorFFS}
                    onChanged={(v) => this.valueChangeMcHMOorFFS(v)}
                />
              </div>,
                <div className="ms-Grid-col ms-u-md2">
                  <Dropdown
                      label="Health plans"
                      options={this.state.healthPlans}
                      selectedKey={data.healthPlanId}
                      onChanged={(v) => this.valueChange("healthPlanId", v)}
                  />
                </div>].filter(() => data.mcHMOorFFS == "HMO")}
              {[<div className="ms-Grid-col ms-u-md4">
                <Dropdown
                    label="HMO or FFS"
                    options={[
                      {key: "HMO", text: "HMO"},
                      {key: "FFS", text: "FFS"},
                    ]}
                    selectedKey={data.mcHMOorFFS}
                    onChanged={(v) => this.valueChangeMcHMOorFFS(v)}
                />
              </div>].filter(() => data.mcHMOorFFS != "HMO")}
              <div className="ms-Grid-col ms-u-md4">
                <DatePicker
                  label="Part B Issue Date"
                  formatDate={(date) => moment(date).format("MMM DD YYYY")}
                  value={data.partBDate}
                  onSelectDate={(v) => this.valueDateChange("partBDate", v)}
                  allowTextInput
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <Dropdown
                  label="HMO or FFS"
                  options={[
                    { key: "HMO", text: "HMO" },
                    { key: "FFS", text: "FFS" },
                  ]}
                  selectedKey={data.HMOorFFS}
                  onChanged={(v) => this.valueChange("HMOorFFS", v)}
                />
              </div>
            </div>
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md4">
                <DatePicker
                    label="Medical Issue Data"
                    formatDate={(date) => moment(date).format("MMM DD YYYY")}
                    value={data.medicareIssueDate}
                    onSelectDate={(v) =>
                        this.valueDateChange("medicareIssueDate", v)
                    }
                    allowTextInput
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Clinic Doctor"
                  value={data.clinicDoctor}
                  onChanged={(v) => this.valueChange("clinicDoctor", v)}
                />
              </div>

              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Insurance Plan"
                  value={data.insurancePlan}
                  onChanged={(v) => this.valueChange("insurancePlan", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                    label="Clinic Name"
                    value={data.clinicName}
                    onChanged={(v) => this.valueChange("clinicName", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Hospital Two"
                  value={data.hospitalTwo}
                  onChanged={(v) => this.valueChange("hospitalTwo", v)}
                />
              </div>

              <div className="ms-Grid-col ms-u-md2">
                <TextField
                  label="Service Start Date"
                  readOnly
                  style={{ background: "#f2f2f2" }}
                  value={moment(data.serviceStartDate).format("MMM DD YYYY")}
                />
              </div>

              <div className="ms-Grid-col ms-u-md2">
                <TextField
                  label="Service End Date"
                  readOnly
                  style={{ background: "#f2f2f2" }}
                  value={moment(data.serviceEndDate).format("MMM DD YYYY")}
                />
              </div>

              {/* <div className="ms-Grid-col ms-u-md4 p0">
                            <div className="ms-Grid-col ms-u-md7">
                                <TextField label="Relative phone" value={data.relativePhone} readOnly="true"/>
                            </div>
                            <div className="ms-Grid-col ms-u-md5">
                                <Label>&nbsp;</Label>
                                <Button tabIndex={-1} buttonType={ButtonType.primary}
                                    onClick={ this._showDialog.bind(this) }>Relative Info</Button>
                            </div>
                        </div> */}


              <div className="ms-Grid-col ms-u-md4">
              <Label>&nbsp;</Label>
              {data.insurancedoc && data.insurancedoc.length>0 &&  (
              <PrimaryButton
                  tabIndex={-1}
                  style={{ marginRight: 10 }}
                  onClick={() => this.viewInsuranceDocList(data._id)}
                >
                  View {}
                </PrimaryButton>)}
              </div>                        
            </div>

            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                    label="Hospital One"
                    value={data.hospitalOne}
                    onChanged={(v) => this.valueChange("hospitalOne", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Relative First Name"
                  value={data.relativeFirstName}
                  onChanged={(v) => this.valueChange("relativeFirstName", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md4">
                <TextField
                  label="Relative Last Name"
                  value={data.relativeLastName}
                  onChanged={(v) => this.valueChange("relativeLastName", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md2">
                <TextField
                  label="Relative phone"
                  value={data.relativePhone}
                  onChanged={(v) => this.valueChange("relativePhone", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md2">
                <Label>&nbsp;</Label>
                <PrimaryButton
                  tabIndex={-1}
                  onClick={this._showDialog.bind(this)}
                >
                  Relative Info
                </PrimaryButton>
              </div>
            </div>

            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Medications"
                  value={data.medications}
                  onChanged={(v) => this.valueChange("medications", v)}
                />
              </div>
            </div>
            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Diagnosis One"
                  value={data.diagnosisOne}
                  onChanged={(v) => this.valueChange("diagnosisOne", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row ">
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Diagnosis Two"
                  value={data.diagnosisTwo}
                  onChanged={(v) => this.valueChange("diagnosisTwo", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-u-md3 ">
                <Dropdown
                  label="HMO Happy"
                  options={[
                    { key: true, text: "Yes" },
                    { key: false, text: "No" },
                  ]}
                  selectedKey={data.hmoHappy}
                  onChanged={(v) => this.valueChange("hmoHappy", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md9">
                <Label>&nbsp;</Label>
                <TextField
                  placeholder="Reason HMO"
                  value={data.homHappyReason}
                  onChanged={(v) => this.valueChange("homHappyReason", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-u-md3 ">
                <Dropdown
                  label="Doctor Happy"
                  options={[
                    { key: true, text: "Yes" },
                    { key: false, text: "No" },
                  ]}
                  selectedKey={data.doctorHappy}
                  onChanged={(v) => this.valueChange("doctorHappy", v)}
                />
              </div>
              <div className="ms-Grid-col ms-u-md9">
                <Label>&nbsp;</Label>
                <TextField
                  placeholder="Reason Doctor"
                  value={data.doctorHappyReason}
                  onChanged={(v) => this.valueChange("doctorHappyReason", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Comment"
                  multiline={true}
                  value={data.comments}
                  onChanged={(v) => this.valueChange("comments", v)}
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-u-md12 ms-u-textAlignRight">
                <DefaultButton
                  tabIndex={-1}
                  style={{ marginRight: 10 }}
                  onClick={() => this.cancel()}
                >
                  Close
                </DefaultButton>
                {this.props.onSave && !this.props.isVendor && (
                  <PrimaryButton onClick={() => this.save()}>
                    {this.state.state == "saving" && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Spinner size={SpinnerSize.xSmall} />
                        {" Saving..."}
                      </div>
                    )}
                    {this.state.state == "saved" && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <i className="ms-Icon ms-Icon--CheckMark"></i>
                        {" Saved"}
                      </div>
                    )}
                    {this.state.state == "editing" && <div>Save</div>}
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>

          {this.state.showInsuranceDocList && this.state.currentdocument && (<Dialog
            isOpen={this.state.showInsuranceDoc}
            type={DialogType.normal}
            onDismiss={this._closeInsuranceDialog.bind(this)}
            title={this.state.currentdocument.filename}
            isBlocking={true}
            containerClassName="insurance-doc"
            style={{maxWidth:1000}}
          >
            
            <iframe src={config.apiUrl + "/customer/get-insurance-doc/"+this.state.currentdocument.id+"?token="+this.props.token} width="500px" height="500px"></iframe>
           
            
            <DialogFooter>
              <DefaultButton onClick={this._closeInsuranceDialog.bind(this)}>
                Close
              </DefaultButton>
            </DialogFooter>

          </Dialog>)}

          {this.state.showInsuranceDocList && data.insurancedoc && (<Dialog
                isOpen={this.state.showInsuranceDocList}
                type={DialogType.normal}
                onDismiss={this._closeInsuranceListDialog.bind(this)}
                title="List of insurance documents"
                isBlocking={true}
                containerClassName="insurance-doc"
                style={{maxWidth:1000}}
              >
                 
                  <DetailsList
                  items={data.insurancedoc}
                  columns={columns}
                  layoutMode={DetailsListLayoutMode.justified}
                  checkboxVisibility={CheckboxVisibility.hidden}
                  style={{ fontSize: 20 }}
                  setKey="_id"                                 
                  />

                <DialogFooter>
                  <DefaultButton onClick={this._closeInsuranceListDialog.bind(this)}>
                    Close
                  </DefaultButton>
                </DialogFooter>

              </Dialog>    
           ) 
          }     
          
          <Dialog
            isOpen={this.state.showDialog}
            type={DialogType.normal}
            onDismiss={this._closeDialog.bind(this)}
            title="Relative Information"
            isBlocking={true}
            containerClassName="relative-info"
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="First name"
                    value={data.relativeFirstName}
                    onChanged={(v) => this.valueChange("relativeFirstName", v)}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Email"
                    value={data.relativeEmailAddress}
                    onChanged={(v) =>
                      this.valueChange("relativeEmailAddress", v)
                    }
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Middle name"
                    value={data.relativeMiddleName}
                    onChanged={(v) => this.valueChange("relativeMiddleName", v)}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Phone"
                    value={data.relativePhone}
                    onChanged={(v) => this.valueChange("relativePhone", v)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Last name"
                    value={data.relativeLastName}
                    onChanged={(v) => this.valueChange("relativeLastName", v)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Address 1"
                    value={data.relativeAddress}
                    onChanged={(v) => this.valueChange("relativeAddress", v)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md12">
                  <TextField
                    label="Address 2"
                    value={data.relativeAddress2}
                    onChanged={(v) => this.valueChange("relativeAddress2", v)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="City"
                    value={data.relativeCity}
                    onChanged={(v) => this.valueChange("relativeCity", v)}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="State"
                    value={data.relativeState}
                    onChanged={(v) => this.valueChange("relativeState", v)}
                  />
                </div>
              </div>
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Zip"
                    value={data.relativeZipCode}
                    onChanged={(v) => this.valueChange("relativeZipCode", v)}
                  />
                </div>
                <div className="ms-Grid-col ms-u-md6">
                  <TextField
                    label="Zip+"
                    value={data.relativeZipCodePlus}
                    onChanged={(v) =>
                      this.valueChange("relativeZipCodePlus", v)
                    }
                  />
                </div>
              </div>
            </div>

            <DialogFooter>
              <PrimaryButton onClick={this._closeDialog.bind(this)}>
                Save
              </PrimaryButton>
              <DefaultButton onClick={this._closeDialog.bind(this)}>
                Cancel
              </DefaultButton>
            </DialogFooter>
          </Dialog>
          
        </div>
      );
    }
    return null;
  }

  _showDialog() {
    this.setState({ showDialog: true });
  }

  _closeDialog() {
    this.setState({ showDialog: false });
  }

  _closeInsuranceDialog() {
    this.setState({ showInsuranceDoc: false,currentdocument:null });
  }

  _closeInsuranceListDialog() {
    this.setState({ showInsuranceDocList: false });
  }  

}

const columns = [
  {
      key: 'filename',
      name: 'File Name',
      fieldName: 'filename',
      minWidth: 300,
      maxWidth: 300,
  },
  {
      key: 'action',
      name: 'Action',
      fieldName: 'action',
      minWidth: 120,
      maxWidth: 120,
  }
]


// WEBPACK FOOTER //
// ./client/components/common/LeadForm/index.js